export const GET_MOBILE = 'getMobile';
export const GET_MENU = 'getMenu';